export const OPEN_DELETE_MODAL = 'OPEN_DELETE_MODAL';
export const CLOSE_DELETE_MODAL = 'CLOSE_DELETE_MODAL';


export const openDeleteEventModal = (deleteData) => ({
    type: OPEN_DELETE_MODAL,
    payload: deleteData
});

export const closeDeleteEventModal = () => ({
    type: CLOSE_DELETE_MODAL
});